/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptContainer } from '../../models/prompt-container';

export interface PromptsPromptIdGet$Params {
  promptId: string;
}

export function promptsPromptIdGet(
  http: HttpClient,
  rootUrl: string,
  params: PromptsPromptIdGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromptContainer>> {
  const rb = new RequestBuilder(rootUrl, promptsPromptIdGet.PATH, 'get');
  if (params) {
    rb.path('promptId', params.promptId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromptContainer>;
      }),
    );
}

promptsPromptIdGet.PATH = '/prompts/{promptId}';
